import React, { useState } from "react";
import Modal from "react-modal";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { notify, formDataHelper } from "../../../../util/helpers";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/CloseIcon.svg";
import { DatePicker, DateRangePicker } from "rsuite";
import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar.svg";
import { CBadge } from "@coreui/react";
import "../../patient/PatientStyles.css";
import moment from "moment";
const customStyles = {
  overlay: {
    backgroundColor: "rgba(11, 17, 71, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
    width: "60%",
    height: "90vh",
  },
};

const Tab = ({ text, callBack, active, count = "" }) => {
  return (
    <div onClick={callBack} className={`hsc-tab${active ? "-selected" : ""}`}>
      {text}
      <CBadge
        style={{ color: "white", backgroundColor: "#2bc2f7" }}
        shape="rounded-circle"
      >
        {count}
      </CBadge>
    </div>
  );
};

const HorizontalSwitcherComponent = ({ currentTab, setCurrentTab }) => {
  return (
    <div className="container-fluid">
      <div className="d-flex">
        <Tab
          text={"Basic Details"}
          callBack={() => {
            setCurrentTab(1);
          }}
          active={currentTab === 1}
        />
        <Tab
          text={"Invoice Setup"}
          callBack={() => {
            setCurrentTab(2);
          }}
          active={currentTab === 2}
        />
      </div>
    </div>
  );
};

const CreateClinic = ({ modalIsOpen, setIsOpen }) => {
  Modal.setAppElement("#root");
  const [loading, setLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState(1);
  const { beforeToday } = DateRangePicker;

  const [contract_date, setContractDate] = useState(null);
  const [onboarding_date, setOnboardingDate] = useState(null);
  const [monthly_billing_effective_date, setMonthlyBillingEffectiveDate] =
    useState(null);
  const [contract_termination_date, setContractTerminationDate] =
    useState(null);

  const dispatch = useDispatch();

  function closeModal() {
    if (loading) {
      notify("Please wait while the HealthCare Group is being created", "info");
      return;
    }
    setCurrentTab(1);
    setIsOpen(false);
  }
  const handleSubmit = (e) => {
    e.preventDefault();

    try {
      if (loading) {
        notify(
          "Please wait while the Clinic details are being recorded",
          "info"
        );
        return;
      }
      setLoading(true);
      let formData = new FormData(e.target);
      const data = formDataHelper(formData, true);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      notify("Something went wrong! Try again later!", "error");
    }
  };

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel=""
      >
        <div className="container-fluid">
          <button
            style={{
              position: "absolute",
              right: "15px",
              border: "0px",
              fontFamily: "DM Sans",
              backgroundColor: "transparent",
            }}
            onClick={closeModal}
          >
            <CloseIcon />
          </button>
          <CardLayout className="p-3">
            <div className="w-100 pt-2 d-flex justify-content-start">
              <h3 className="primary-text-blue">Create Clinic</h3>
            </div>
            <HorizontalSwitcherComponent
              currentTab={currentTab}
              setCurrentTab={setCurrentTab}
            />
            <form onSubmit={handleSubmit} className="container-fluid">
              {currentTab === 1 ? (
                <div
                  style={{
                    margin: "0px",
                    padding: "0px",
                    width: "100%",
                    display: currentTab === 1 ? "inline-flex" : "none",
                  }}
                  className="row"
                >
                  <div className="col-sm-12 col-md-6 col-lg-6">
                    <div className="form-group py-3">
                      <label>Health Group *</label>
                      <input
                        tabindex="1"
                        required
                        name="health_group"
                        id="health_group"
                        placeholder="Enter Health Group Name"
                      />
                    </div>
                    <div className="form-group py-3">
                      <label>Rose Sales Team Manager</label>
                      <input
                        tabindex="3"
                        name="rose_sales_member"
                        id="rose_sales_member"
                        required
                        placeholder="Enter Full Name"
                      />
                    </div>
                    <div className="form-group py-3">
                      <label>Primary Contact</label>
                      <input
                        tabindex="5"
                        name="cell_number"
                        id="cell_number"
                        maxLength={10}
                        minLength={10}
                        placeholder="Enter Phone Number"
                      />
                    </div>
                    <div className="form-group py-3">
                      <label>Street Address 2</label>
                      <input
                        tabindex="7"
                        name="street_address_2"
                        id="street_address_2"
                        required
                        placeholder="Continue with address"
                      />
                    </div>
                    <div className="form-group py-3">
                      <label>State</label>
                      <input
                        tabindex="9"
                        name="state"
                        id="state"
                        maxLength={14}
                        placeholder="Enter State Name"
                      />
                    </div>
                    <div className="form-group py-3">
                      <label>Country</label>
                      <input
                        tabindex="11"
                        name="Country"
                        id="Country"
                        maxLength={14}
                        placeholder="Enter Country"
                      />
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6">
                    <div className="form-group py-3">
                      <label>Clinic Name *</label>
                      <input
                        tabindex="2"
                        required
                        name="clinic_name"
                        id="clinic_name"
                        placeholder="Enter Clinic Name"
                      />
                    </div>
                    <div className="form-group py-3">
                      <label>Primary Email</label>
                      <input
                        tabindex="4"
                        type="email"
                        placeholder="Enter Email Address"
                        name="email"
                        id="email"
                      />
                    </div>
                    <div className="form-group py-3">
                      <label>Street Address 1</label>
                      <input
                        tabindex="6"
                        name="street_address_1"
                        id="street_address_1"
                        required
                        placeholder="Lane, bulding, house no."
                      />
                    </div>
                    <div className="form-group py-3">
                      <label>City</label>
                      <input
                        tabindex="8"
                        name="city"
                        id="city"
                        maxLength={14}
                        placeholder="Enter City Name"
                      />
                    </div>
                    <div className="form-group py-3">
                      <label>Zip Code</label>
                      <input
                        tabindex="10"
                        name="zip_code"
                        id="zip_code"
                        maxLength={14}
                        placeholder="Enter Zip Code"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    margin: "0px",
                    padding: "0px",
                    width: "100%",
                    display: currentTab === 2 ? "inline-flex" : "none",
                  }}
                >
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="d-flex justify-content-between my-2">
                      <div className="form-group py-3" style={{ width: "30%" }}>
                        <label>One-time setup fee *</label>
                        <input
                          type="number"
                          tabindex="1"
                          required
                          name="one-time-fee"
                          id="one-time-fee"
                          placeholder="$--"
                        />
                      </div>
                      <div className="form-group py-3" style={{ width: "30%" }}>
                        <label>Number of Providers*</label>
                        <input
                          type="number"
                          tabindex="2"
                          required
                          name="providers"
                          id="provders"
                          placeholder="Enter number of Providers"
                        />
                      </div>
                      <div className="form-group py-3" style={{ width: "30%" }}>
                        <label>Total setup fees*</label>
                        <input
                          type="number"
                          tabindex="3"
                          required
                          name="total-setup-fees"
                          id="total-setup-fees"
                          placeholder="$--"
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-between">
                      <div className="form-group py-3" style={{ width: "30%" }}>
                        <label>Monthly subscription fees</label>
                        <input
                          type="number"
                          tabindex="4"
                          required
                          name="monthly-subscription-fee"
                          id="monthly-subscription-fee"
                          placeholder="$--"
                        />
                      </div>
                      <div className="form-group py-3" style={{ width: "30%" }}>
                        <label>Number of Providers*</label>
                        <input
                          type="number"
                          tabindex="5"
                          required
                          name="providers"
                          id="provders"
                          placeholder="Enter number of Providers"
                        />
                      </div>
                      <div className="form-group py-3" style={{ width: "30%" }}>
                        <label>Number of Months to be Paid</label>
                        <input
                          type="number"
                          tabindex="6"
                          required
                          name="total-months"
                          id="total-months"
                          placeholder="$--"
                        />
                      </div>
                    </div>
                    <div className="d-flex my-2">
                      <div className="form-group py-3" style={{ width: "30%" }}>
                        <label>Charged every ? month(s)</label>
                        <input
                          type="number"
                          tabindex="7"
                          required
                          name="monthly_charges"
                          id="monthly_charges"
                          placeholder="$--"
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-between my-2">
                      <div className="form-group py-3" style={{ width: "48%" }}>
                        <label>Contract Effective Date</label>
                        <DatePicker
                          tabindex="8"
                          placeholder="-- --"
                          appearance="subtle"
                          name="contract_date"
                          id="contract_date"
                          value={contract_date}
                          oneTap
                          onChange={setContractDate}
                          caretAs={CalendarIcon}
                          format="MM/dd/yyyy"
                          className="custom-datepicker"
                        />
                      </div>
                      <div className="form-group py-3" style={{ width: "48%" }}>
                        <label>Onboarding Date</label>
                        <DatePicker
                          tabindex="9"
                          placeholder="-- --"
                          appearance="subtle"
                          name="onboarding_date"
                          id="onboarding_date"
                          value={onboarding_date}
                          oneTap
                          onChange={setOnboardingDate}
                          caretAs={CalendarIcon}
                          shouldDisableDate={beforeToday()}
                          format="MM/dd/yyyy"
                          className="custom-datepicker"
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-between my-2">
                      <div className="form-group py-3" style={{ width: "48%" }}>
                        <label>Trial Days</label>
                        <input
                          type="number"
                          tabindex="10"
                          required
                          name="trial_days"
                          id="trial_days"
                          placeholder="00"
                        />
                      </div>
                      <div className="form-group py-3" style={{ width: "48%" }}>
                        <label>Monthly Billing Effective Date</label>
                        <DatePicker
                          tabindex="11"
                          placeholder="-- --"
                          appearance="subtle"
                          name="monthly_billing_effective_date"
                          id="monthly_billing_effective_date"
                          value={monthly_billing_effective_date}
                          oneTap
                          onChange={setMonthlyBillingEffectiveDate}
                          caretAs={CalendarIcon}
                          format="MM/dd/yyyy"
                          className="custom-datepicker"
                        />
                      </div>
                    </div>
                    <div className="d-flex my-2">
                      <div className="form-group py-3" style={{ width: "48%" }}>
                        <label>Contract Termination Date</label>
                        <DatePicker
                          tabindex="12"
                          placeholder="-- --"
                          appearance="subtle"
                          name="contract_termination_date"
                          id="contract_termination_date"
                          value={contract_termination_date}
                          oneTap
                          onChange={setContractTerminationDate}
                          caretAs={CalendarIcon}
                          format="MM/dd/yyyy"
                          className="custom-datepicker"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div
                className="container-fluid w-100 d-flex justify-content-end"
                style={{ gap: "30px" }}
              >
                <button
                  className="btn alternative-btn"
                  style={{ padding: "10px 20px", width: "20%" }}
                  onClick={() => {
                    if (currentTab === 1) {
                      closeModal();
                    } else {
                      setCurrentTab(1);
                    }
                  }}
                >
                  {currentTab === 1 ? "Cancel" : "Back"}
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="primary-btn"
                  style={{ padding: "10px 20px !important", width: "20%" }}
                >
                  {currentTab === 1 ? "Next" : "Submit"}
                </button>
              </div>
            </form>
          </CardLayout>
        </div>
      </Modal>
    </div>
  );
};

export default CreateClinic;
